export const documentProps = {
  title: 'Case Studies — Real Results from Real Clients',
  description:
    'See how TenK Solutions saved a medical practice $25,670, eliminated $45K in outsourcing costs for an AEC firm, and cut 27% of telecom costs for a nonprofit. Real numbers, real clients.',
};
